import { FC, lazy, Suspense } from "react";
import {
  CircularProgress,
  CssBaseline,
  ErrorBoundary,
  makeStyles,
  ThemeProvider,
} from "@xcira/components";
import { Switch, Route } from "react-router-dom";
import { theme } from "../theme";

const BidderView = lazy(() => import("./BidderView"));
const TechCoordView = lazy(() => import("./TechCoordView"));
const AuctionCommandCenterView = lazy(() => import("./AccView"));
const AuctionMarqueeCenterView = lazy(() => import("./AmcView"));

const useStyles = makeStyles()(() => ({
  loader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
}));

const App: FC = () => {
  const { classes } = useStyles();

  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        }
      >
        <Switch>
          <Route exact path="/">
            <ThemeProvider theme={theme}>
              <CssBaseline />

              <BidderView />
            </ThemeProvider>
          </Route>

          <Route path="/techcoord">
            <TechCoordView />
          </Route>

          <Route path="/acc">
            <AuctionCommandCenterView />
          </Route>

          <Route path="/amc">
            <AuctionMarqueeCenterView />
          </Route>
        </Switch>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
